// extracted by mini-css-extract-plugin
module.exports = {"mouseGlow":"MouseGlow_mouseGlow__1w5YY","passive":"MouseGlow_passive__jBYXE"};